<template>
  <slot>
    <div :class="wrapperClasses" :id="identifier" v-show="!state.hidden">
      <label class="govuk-label" :for="controlId" v-show="!state.hiddenLabel" v-html="displayName"> </label>
      <div :id="titleId" class="govuk-title" v-html="displayTitle"></div>

      <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
      <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

      <span :id="errorId" class="govuk-error-message">
        <span :id="errorId" class="govuk-error-message">
          <ul v-if="currentErrors.length > 0">
            <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
              {{ errorMessage.message }}
            </li>
          </ul>
        </span>
      </span>
      <textarea
        v-on:blur="focusOut()"
        class="govuk-input"
        :id="controlId"
        rows="5"
        :name="controlId"
        :disabled="state.readOnly"
        title=""
        :aria-describedby="hintId"
        v-model="state.value"
      ></textarea>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/TextArea.ts"></script>
